export default __webpack_public_path__ + "static/media/screenShots_web-1.e91adfc2.jpg";